export default __webpack_public_path__ + "static/media/help.feccff3f.png";